import React, { useState } from "react";
import { Redirect } from 'react-router-dom';

import { getSystemSettings, setSessionId } from '../../utils/SettingsRetriever';
import SalesIDRetriever from '../../utils/SalesIDRetriever';
import request from '../../utils/request';

import { emptyCart } from "../../services/cart";

import Button from "../Button";
import Icon from "../Icon";

import "./index.scss";

export default function ErrorPage(props){
    const [redirect, setRedirect] = useState(false);
    const [ redirectToHome, setRedirectToHome ] = useState(false);
    const { title, subtitle, children, logo, noReturn = false } = props;

    function createMarkup(string) {
        return {__html: string};
    }

    function checkReturnAction() {
        if (getSystemSettings().app && getSystemSettings().app.checkout && getSystemSettings().app.checkout.customErrorRedirect && getSystemSettings().app.checkout.customErrorRedirect.enabled) goToMainPage();
        else setRedirect(true);
    }

    function goToMainPage() {
        request({
            url: getSystemSettings().api + '/inntopia/session?salesid=' + SalesIDRetriever(),
            method: 'GET'
        })
        .then( (result) => {
            emptyCart();
            setSessionId(result.data.SessionId);
            setRedirectToHome(true);
        });
    }

    if (redirectToHome) {
        return <Redirect to={getSystemSettings().urlPrefix} />;
    }

    if(redirect) {
        const url = '/checkout/review';
        return <Redirect to={getSystemSettings().urlPrefix + url} />;
    }

    return (
        <div className="errorPage">
            <div className="errorPageContainer">
                <div className="errorPageBody">
                    <div className="logo">
                    {
                        logo 
                        ? <img src={logo} alt="" />
                        : <Icon icon="feather-alert-triangle" />
                    }
                    </div>
                    <div className="errorTitle" dangerouslySetInnerHTML={createMarkup(title)} />
                    <div className="errorSubtitle" dangerouslySetInnerHTML={createMarkup(subtitle)} />
                    {children}
                    {
                        !noReturn &&
                        <div className="bottomCTADesktop">
                            <Button onClick={() => checkReturnAction()}>
                                <span className="goBackText">
                                    Return
                                </span>
                            </Button>
                        </div>
                    }
                </div>
            </div>
            {
                !noReturn &&
                <div className="bottomCTA">
                    <Button onClick={() => setRedirect(true)}>
                        <Icon icon="feather-arrow-right" />
                        <span className="goBackText">
                            Return
                        </span>
                    </Button>
                </div>
            }
        </div>
    )
}